import React, { useEffect, useState } from "react";
import { Grid, Button } from "semantic-ui-react";
import { Field, FieldArray } from "redux-form";
import { renderTextField, renderDatePicker , renderOptionField} from "../formcomponents";
import AttractionItenery from "./AttractionItenery";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";
import { HotelData } from "./HotelData";
const TourDayItenery = ({
  fields,

  meta: { touched, error, submitFailed },
}) => {
  useEffect(() => {
    if (fields.length == 0) {
      fields.push({});
    }
  }, []);

  const [driverList, setdriverList] = useState([]);
  const [carList, setcarList] = useState([]);

  const [serviceType, setServiceTuype] = useState([
    {
      text:'Dubai Full package',
      value:1
    },   {
      text:'Abudhabi package',
      value:2
    },   {
      text:'Hotels only ',
      value:3
    },
  ]);

  useEffect(() => {
    getEmployeeList();
    getVechileList();
   
  }, []);

  const getVechileList = async () => {
    await axios
      .post(BaseUrlInvoice + "accounts/listVehicle", { vehicleId: 1 })
      .then((res) => {
        console.log(res.data);

        const filterItem = res.data;
        let tempArr = [];
        for (let i = 0; i < filterItem.length; i++) {
          tempArr.push({
            text: filterItem[i].vehicleBrand + "-" + filterItem[i].model,
            value: filterItem[i].vehicleId,
          });
        }
        setcarList(tempArr);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getEmployeeList = async () => {
    await axios
      .get(BaseUrl + "getBackOfficeUserList")
      .then((res) => {
        console.log(res.data);
        const tempData = res.data;
        const filterItem = tempData.filter((item) => item.userRole == 6);
        console.log("filterItem", filterItem);
        let tempArr = [];
        for (let i = 0; i < filterItem.length; i++) {
          tempArr.push({
            text: filterItem[i].userFirstName + filterItem[i].userLastName,
            value: filterItem[i].userId,
          });
        }
        setdriverList(tempArr);
      })
      .catch((error) => {
        console.log(error);
      });
  };


  return (
    <ul>
      {fields.map((item, tourDayindex) => (
        <Grid
          columns={6}
          style={{
            backgroundColor: "#92a8d1",
            marginBottom: "20px",
          }}
        >
          <h2>Day {tourDayindex + 1}</h2>   <li key={tourDayindex} style={{ listStyleType: "none" }}>
            {tourDayindex != 0 && (
              <Button
                type="button"
                floated="left"
                negative
                onClick={() => fields.remove(tourDayindex)}
              >
                X
              </Button>
            )}
            {fields.length - 1 === tourDayindex && (
              <Button
                type="button"
                positive
                floated="right"
                onClick={() => fields.push({})}
              >
                Add Day
              </Button>
            )}
          </li>

          <Grid.Row>
            <Grid.Column>
              <Field
                name={`${item}.travelDate`}
                type="date"
                minDate={
                  tourDayindex > 0 ? fields.get(tourDayindex - 1).travelDate : new Date()
                }
                component={renderDatePicker}
                label="Date"
              />
            </Grid.Column>

            <Grid.Column>
              <Field
                name={`${item}.service`}
                options={serviceType}
                component={renderOptionField}
                label="Service"
              />
            </Grid.Column>

            <Grid.Column>
              {" "}
              <Field
                name={`${item}.driverId`}
                options={driverList}
              component={renderOptionField}
                label="Driver Name"
              />{" "}
            </Grid.Column>
            <Grid.Column>
              {" "}
              <Field
                name={`${item}.vehicleId`}
                options={carList}
                component={renderOptionField}
                label="Vechile"
              />{" "}
            </Grid.Column>
            <Grid.Column>
              {" "}
              <Field
                name={`${item}.pickupLocation`}
                type="text"
                component={renderTextField}
                label="Pickup Location"
              />{" "}
            </Grid.Column>
            <Grid.Column>
              {" "}
              <Field
                name={`${item}.pickupTime`}
                type="text"
                component={renderTextField}
                label="Pickup Time"
              />{" "}
            </Grid.Column>
            <Grid.Column>
              {" "}
              <Field
                name={`${item}.dropLocation`}
                type="text"
                component={renderTextField}
                label="Drop Location"
              />{" "}
            </Grid.Column>
            <Grid.Column>
              {" "}
              <Field
                name={`${item}.dropTime`}
                type="text"
                component={renderTextField}
                label="Drop Time"
              />{" "}
            </Grid.Column>
            <Grid.Column>
              {" "}
              <Field
                name={`${item}.cost`}
                type="text"
                component={renderTextField}
                label="Cost"
              />{" "}
            </Grid.Column>

            <Grid.Column>
              <Field
                name={`${item}.hotelName`}
                options={HotelData}
                component={renderOptionField}
                label="Hotel Name"
              />
            </Grid.Column>

            <Grid.Column>
              <Field
                name={`${item}.totalCost`}
                type="text"
                component={renderTextField}
                label="Cost"
              />
            </Grid.Column>
          </Grid.Row>

         

          <FieldArray
                name={`${item}.tourAttractionList`}
                component={AttractionItenery}
              />

          <br />
         
        </Grid>
      ))}
      <br />
      {(touched || submitFailed) && error && <span>{error}</span>}
    </ul>
  );
};

export default TourDayItenery;
